module.exports = {"350112001":"吴航街道","350112002":"航城街道","350112003":"营前街道","350112004":"漳港街道","350112005":"文武砂街道","350112102":"首占镇","350112103":"玉田镇","350112104":"松下镇","350112105":"江田镇","350112106":"古槐镇","350112108":"鹤上镇","350112110":"湖南镇","350112111":"金峰镇","350112112":"文岭镇","350112113":"梅花镇","350112114":"潭头镇","350112200":"罗联乡","350112201":"猴屿乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350112.json
// module id = 1274
// module chunks = 0